module.exports = __webpack_public_path__ + "static/img/join-us.fb0d38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/join-us.png
// module id = IFRt
// module chunks = 1